import { ServiceDeliveryService } from './../../children/service-delivery/service/service-delivery.service';
import { PartyRoleTypes } from 'src/app/component/party/model/party-role-types.model';
import { PartyServiceStatusTypes } from './../model/party-service-status-types.model';
import { ServiceCategories } from './../../common-components/child-services/model/service-categories.model';
import { ServiceHours } from './../model/service-hours.model';
import { SsdpComponents } from './../model/ssdp-components.model';
import { FederalCategories } from './../model/federal-categories.model';
import { MeasurableProgramObjectives } from './../model/measurable-program-objectives.model';
import { FederalCodes } from './../model/federal-codes.model';
import { Region } from 'src/app/model/region.model';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { PartyServices } from './../model/party-services.model';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { ServiceAdministrationService } from '../service/service-administration.service';
import { Grade } from 'src/app/model/school.model';
import { Observable, forkJoin, map, throwError, catchError, of, Subscription } from 'rxjs';
import { PartyServiceTypes } from '../model/party-service-types.model';
import { MatTableDataSource } from '@angular/material/table';
import { EnrollmentPeriods } from '../../common-components/child-services/model/enrollment-periods.model';
import { ErrorMsgDialogComponent } from '../../common-components/error-msg-dialog/error-msg-dialog.component';

@Component({
    selector: 'edit-service-administration',
    templateUrl: './edit-service-administration.component.html',
    styleUrls: ['./edit-service-administration.component.scss']
})
export class EditServiceAdministrationComponent implements OnInit {
    @ViewChild('serviceAdministrationForm') serviceAdministrationForm: FormGroupDirective;

    partyService: PartyServices;
    form: UntypedFormGroup;
    chosenRegion: Region;
    selectRegionIds: number[] = [];
    regionDisabled: boolean = false;

    grades: Grade[] = [];
    gradesDisabled: boolean = false;

    stateServices: FederalCodes[];
    measurableProgramObjectives: MeasurableProgramObjectives[];
    federalCategories: FederalCategories[];
    ssdpComponents: SsdpComponents[];
    serviceHours: ServiceHours[];
    serviceCategories: ServiceCategories[];
    serviceProviders: PartyRoleTypes[];
    partyServiceStatusTypes: PartyServiceStatusTypes[];
    enrollmentPeriods: EnrollmentPeriods[];

    disabledFields: string[] = ['serviceHour'];

    isLoading: boolean = false;
    msg: MsgModel = {};
    showMsg: boolean = false;
    submitting: boolean = false;

    getPropertyPipe = new GetPropertyPipe();

    featurePermissions = {
        'Edit Federal Category': { has: false },
        'Edit Service Category': { has: false }
    };

    formChanges: any = {};

    // Table display for current changes
    displayedColumns: string[] = ['CHANGED_FIELD', 'VALUE', 'CHANGED_VALUE'];

    // Table results for current changes
    tableDataSource: MatTableDataSource<any>;

    subs: Subscription[] = [];

    constructor(
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ServiceAdministrationService>,
        private serviceAdministrationService: ServiceAdministrationService,
        private serviceDeliveryService: ServiceDeliveryService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        fb: UntypedFormBuilder
    ) {
        this.form = fb.group({
            name: ['', [Validators.required]],
            description: ['', [Validators.required]],
            serviceCode: ['', [Validators.required]],
            federalCode: [''],
            mpo: [''],
            serviceHour: [{ value: '', disabled: true }],
            federalCategory: ['', [Validators.required]],
            serviceCategory: ['', [Validators.required]],
            serviceProvider: ['', [Validators.required]],
            serviceStatus: ['', [Validators.required]]
        });

        if (this.data.mode === 'Edit') {
            this.regionDisabled = true;
            this.disableFields(['serviceCode']);
        }
    }

    ngOnInit(): void {
        this.getAll();
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    getAll() {
        this.isLoading = true;
        this.msg = {};

        let obs: Observable<any>[] = [];

        if (this.data.mode !== 'Add') {
            obs.push(this.getServiceAdministration());
        }
        obs.push(this.getStateServices());
        obs.push(this.getMeasurableProgramObjectives());
        obs.push(this.getFederalCategories());
        obs.push(this.indexSSDPComponents());
        obs.push(this.indexServiceHours());
        obs.push(this.indexServiceCategories());
        obs.push(this.indexServiceProviders());
        obs.push(this.indexPartyServiceStatusTypes());
        obs.push(this.getEnrollmentPeriods());
        //obs.push(this.getpartyServiceHistories());
        //obs.push(this.getPermissions());

        forkJoin(obs).subscribe((res) => {
            // Set form fields
            this.addReferenceToForm();
            if (this.data.mode !== 'Add') {
                this.setForm(this.partyService);
            }

            // Setup tracking history changes
            this.initCurrentChanges();

            setTimeout(() => {
                this.setCurrentChanges();
                this.updateDataSource();
            }, 1000);

            this.subscribers();

            this.isLoading = false;
        });
    }

    initCurrentChanges() {
        // Static Form Group
        this.formChanges['name'] = { CHANGED_FIELD: 'Service Name', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['description'] = { CHANGED_FIELD: 'Service Description', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['serviceCode'] = { CHANGED_FIELD: 'Service Code', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['federalCode'] = { CHANGED_FIELD: 'State Service Code', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['mpo'] = { CHANGED_FIELD: 'Measurable Program Objective', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['serviceHour'] = { CHANGED_FIELD: 'Service Hour', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['federalCategory'] = { CHANGED_FIELD: 'Federal Category', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['serviceCategory'] = { CHANGED_FIELD: 'Service Category', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['serviceProvider'] = { CHANGED_FIELD: 'Provided By', VALUE: '', CHANGED_VALUE: '' };
        this.formChanges['serviceStatus'] = { CHANGED_FIELD: 'Service Status', VALUE: '', CHANGED_VALUE: '' };

        // SSDP Components
        this.ssdpComponents.forEach((ssdpComponent) => {
            this.formChanges[ssdpComponent.NAME!] = { CHANGED_FIELD: 'SSDP Components', VALUE: '', CHANGED_VALUE: '' };
        });

        // Child Federal Category
        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                this.formChanges[federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString()] = {
                    CHANGED_FIELD: 'Federal Sub Category',
                    VALUE: '',
                    CHANGED_VALUE: ''
                };
            }
        });

        // Grades
        this.formChanges['grades'] = { CHANGED_FIELD: 'Service Grades', VALUE: '', CHANGED_VALUE: '' };

        // Enrollment Periods
        this.enrollmentPeriods.forEach((enrollmentPeriod) => {
            this.formChanges[enrollmentPeriod.PERIOD!] = { CHANGED_FIELD: 'Service Periods', VALUE: '', CHANGED_VALUE: '' };
        });
    }

    setCurrentChanges() {
        // Static Form Group
        this.formChanges['name'].VALUE = this.form.get('name')?.value;
        this.formChanges['description'].VALUE = this.form.get('description')?.value;
        this.formChanges['serviceCode'].VALUE = this.form.get('serviceCode')?.value;
        this.formChanges['federalCode'].VALUE = this.form.get('federalCode')?.value;
        this.formChanges['mpo'].VALUE = this.form.get('mpo')?.value;
        this.formChanges['serviceHour'].VALUE = this.form.get('serviceHour')?.value;
        this.formChanges['federalCategory'].VALUE = this.form.get('federalCategory')?.value;
        this.formChanges['serviceCategory'].VALUE = this.form.get('serviceCategory')?.value;
        this.formChanges['serviceProvider'].VALUE = this.form.get('serviceProvider')?.value;
        this.formChanges['serviceStatus'].VALUE = this.form.get('serviceStatus')?.value;

        // SSDP Components
        this.ssdpComponents.forEach((ssdpComponent) => {
            this.formChanges[ssdpComponent.NAME!].VALUE = this.form.get([ssdpComponent.NAME!])?.value;
        });

        // Child Federal Category
        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                this.formChanges[federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString()].VALUE = this.form.get(
                    federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString()
                )?.value;
            }
        });

        // Grades
        if (this.grades) {
            this.formChanges['grades'].VALUE = this.grades
                .sort((a: any, b: any) => (a.INDEX! > b.INDEX! ? 1 : -1))
                .map((g) => g.GRADES)
                .join(', ');
        }

        // Enrollment Periods
        this.enrollmentPeriods.forEach((enrollmentPeriod) => {
            this.formChanges[enrollmentPeriod.PERIOD!].VALUE = this.form.get([enrollmentPeriod.PERIOD!])?.value;
        });

        // Set same value
        Object.keys(this.formChanges).forEach((key) => {
            this.formChanges[key].CHANGED_VALUE = this.formChanges[key].VALUE;
        });
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<any>();
            this.tableDataSource.data = this.generateCurrentChangesTable();

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                //const dataStr = JSON.stringify(data).toLowerCase();
                //return dataStr.indexOf(filter) != -1;
                return data.CHANGED;
            };

            // Will always run the filterPredicate when filter has a value in it
            this.tableDataSource.filter = 'changed_only';
        });
    }

    generateCurrentChangesTable() {
        let result: any[] = [];

        // Form Group
        Object.keys(this.formChanges).forEach((key) => {
            let CHANGED_FIELD = this.formChanges[key].CHANGED_FIELD;
            let VALUE = this.formChanges[key].VALUE;
            let CHANGED_VALUE = this.formChanges[key].CHANGED_VALUE;

            if (typeof VALUE === 'object' && !Array.isArray(VALUE) && VALUE !== null) {
                if (VALUE['NAME']) {
                    VALUE = VALUE['NAME'];
                }
                // State Code Number
                else if (VALUE['SERVICE_CODE'] && VALUE['SERVICE_NAME']) {
                    VALUE = VALUE['SERVICE_CODE'] + ' - ' + VALUE['SERVICE_NAME'];
                }
                // Federal Category
                else if (VALUE['PARENT_SERVICE_TYPES']) {
                    VALUE = VALUE['PARENT_SERVICE_TYPES'].TYPE;
                }
            }
            if (typeof CHANGED_VALUE === 'object' && !Array.isArray(CHANGED_VALUE) && CHANGED_VALUE !== null) {
                if (CHANGED_VALUE['NAME']) {
                    CHANGED_VALUE = CHANGED_VALUE['NAME'];
                }
                // State Code Number
                else if (CHANGED_VALUE['SERVICE_CODE'] && CHANGED_VALUE['SERVICE_NAME']) {
                    CHANGED_VALUE = CHANGED_VALUE['SERVICE_CODE'] + ' - ' + CHANGED_VALUE['SERVICE_NAME'];
                }
                // Federal Category
                else if (CHANGED_VALUE['PARENT_SERVICE_TYPES']) {
                    CHANGED_VALUE = CHANGED_VALUE['PARENT_SERVICE_TYPES'].TYPE;
                }
            }

            switch (CHANGED_FIELD) {
                case 'Federal Sub Category':
                    if (CHANGED_VALUE === '' || !CHANGED_VALUE) {
                        CHANGED_VALUE = false;
                    }
                    if (VALUE !== CHANGED_VALUE) {
                        result.push({
                            CHANGED_FIELD: CHANGED_FIELD,
                            VALUE: VALUE ? key.split('|')[0] : '',
                            CHANGED_VALUE: CHANGED_VALUE ? key.split('|')[0] : '',
                            CHANGED: true
                        });
                    }
                    break;
                case 'SSDP Components':
                case 'Service Periods':
                    let index = result.findIndex((r) => r.CHANGED_FIELD === CHANGED_FIELD);

                    if (index >= 0) {
                        if (VALUE) {
                            result[index].VALUE = result[index].VALUE ? [result[index].VALUE, key].join(', ') : key;
                        }
                        if (CHANGED_VALUE) {
                            result[index].CHANGED_VALUE = result[index].CHANGED_VALUE ? [result[index].CHANGED_VALUE, key].join(', ') : key;
                        }

                        if (result[index].VALUE !== result[index].CHANGED_VALUE) {
                            result[index].CHANGED = true;
                        }
                    } else {
                        let obj = {
                            CHANGED_FIELD: CHANGED_FIELD,
                            VALUE: '',
                            CHANGED_VALUE: '',
                            CHANGED: false
                        };

                        if (VALUE) {
                            obj.VALUE = key;
                        }
                        if (CHANGED_VALUE) {
                            obj.CHANGED_VALUE = key;
                        }
                        if (obj.VALUE !== obj.CHANGED_VALUE) {
                            obj.CHANGED = true;
                        }

                        result.push(obj);
                    }

                    break;

                default:
                    result.push({
                        CHANGED_FIELD: CHANGED_FIELD,
                        VALUE: VALUE,
                        CHANGED_VALUE: CHANGED_VALUE,
                        CHANGED: VALUE !== CHANGED_VALUE
                    });
                    break;
            }
        });

        return result;
    }

    subscribers() {
        let formSub = this.form.valueChanges.subscribe(() => {
            let changes = this.form.getRawValue();
            Object.keys(changes).forEach((key) => {
                this.formChanges[key].CHANGED_VALUE = changes[key];
            });

            this.updateDataSource();
        });
        this.subs.push(formSub);
    }

    getServiceAdministration() {
        return this.serviceAdministrationService.show(this.data.serviceAdministrationId).pipe(
            map((res: any) => {
                if (res.partyService) {
                    this.partyService = res.partyService;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Service Administration.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getStateServices() {
        return this.serviceAdministrationService.getStateServices().pipe(
            map((res: any) => {
                if (res.stateServices) {
                    this.stateServices = res.stateServices;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving State Services.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getMeasurableProgramObjectives() {
        return this.serviceAdministrationService.getMeasurableProgramObjectives().pipe(
            map((res: any) => {
                if (res.measurableProgramObjectives) {
                    this.measurableProgramObjectives = res.measurableProgramObjectives;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Measurable Program Objectives.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getFederalCategories() {
        return this.serviceAdministrationService.getFederalCategories().pipe(
            map((res: any) => {
                if (res.federalCategories) {
                    this.federalCategories = res.federalCategories;

                    this.federalCategories.forEach((fc) => {
                        fc.ENABLED = true;
                    });

                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Federal Categories.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    indexSSDPComponents() {
        return this.serviceAdministrationService.indexSSDPComponents().pipe(
            map((res: any) => {
                if (res.ssdpComponents) {
                    this.ssdpComponents = res.ssdpComponents;
                    this.ssdpComponents = this.ssdpComponents.sort((a, b) => {
                        const activeSort = (b.ACTIVE === true ? 1 : 0) - (a.ACTIVE === true ? 1 : 0);

                        if (activeSort !== 0) {
                            return activeSort;
                        }

                        const getMpo = (name?: string): number => parseFloat(name?.match(/\(MPO\s+([\d.]+)\)/i)?.[1] ?? 'Infinity');

                        return getMpo(a.NAME) - getMpo(b.NAME);
                    });

                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving SSDP Components.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    indexServiceHours() {
        return this.serviceAdministrationService.indexServiceHours().pipe(
            map((res: any) => {
                if (res.serviceHours) {
                    this.serviceHours = res.serviceHours;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Service Hours.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    indexServiceCategories() {
        return this.serviceAdministrationService.indexServiceCategories().pipe(
            map((res: any) => {
                if (res.serviceCategories) {
                    this.serviceCategories = res.serviceCategories;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Service Categories.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    indexServiceProviders() {
        return this.serviceAdministrationService.indexServiceProviders().pipe(
            map((res: any) => {
                if (res.serviceProviders) {
                    this.serviceProviders = res.serviceProviders;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Service Providers.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    indexPartyServiceStatusTypes() {
        return this.serviceAdministrationService.indexPartyServiceStatusTypes().pipe(
            map((res: any) => {
                if (res.partyServiceStatusTypes) {
                    this.partyServiceStatusTypes = res.partyServiceStatusTypes;
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Service Status Types.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getEnrollmentPeriods() {
        return this.serviceDeliveryService.getEnrollmentPeriods().pipe(
            map((res: any) => {
                if (res.result) {
                    this.enrollmentPeriods = res.result.filter((ep: EnrollmentPeriods) => {
                        return ep.PERIOD == 'Regular Year' || ep.PERIOD == 'Summer' || ep.PERIOD == 'Intersession';
                    });
                    return res;
                } else if (res.msg) {
                    this.msg = res.msg;
                    return res;
                } else {
                    return throwError(() => new Error('Error retrieving Enrollment Periods.'));
                }
            }),
            catchError((err) => {
                return of(err);
            })
        );
    }

    getpartyServiceHistories() {}

    getPermissions() {}

    getPartyService() {
        let partyService: PartyServices = new PartyServices();

        partyService = JSON.parse(JSON.stringify(this.partyService));
        partyService.SERVICE_NAME = this.form.get('name')?.value;
        partyService.DESCRIPTION = this.form.get('description')?.value;

        return partyService;
    }

    submit() {
        if (this.checkValid()) {
            this.showMsg = false;
            if (this.data.mode === 'Add') {
                this.create();
            } else {
                this.save();
            }
        }
    }

    checkValid() {
        if (this.serviceAdministrationForm) {
            if (this.serviceAdministrationForm.valid && this.grades.length > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    create() {
        this.submitting = true;

        this.serviceAdministrationService.create(this.generatePayload()).subscribe({
            next: (res) => {
                if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = { SUCCESS: false, MSG: 'Error creating Service Adminstrations.' };
                }
            },
            error: (err) => {
                this.msg = { SUCCESS: false, MSG: 'Error creating Service Adminstrations.' };
                this.submitting = false;
                this.showMsg = true;
            },
            complete: () => {
                // Display results
                this.submitting = false;
                this.showMsg = true;

                if (this.msg.SUCCESS) {
                    this.closeDialog(true);
                } else {
                    this.dialog.open(ErrorMsgDialogComponent, {
                        width: '400px',
                        data: { title: 'Error Creating Service', message: this.msg.MSG }
                    });
                }
            }
        });
    }

    save() {
        this.submitting = true;

        this.serviceAdministrationService.update(this.generatePayload()).subscribe({
            next: (res) => {
                if (res.msg) {
                    this.msg = res.msg;
                } else {
                    this.msg = { SUCCESS: false, MSG: 'Error updating Service Adminstrations.' };
                }
            },
            error: (err) => {
                this.msg = { SUCCESS: false, MSG: 'Error updating Service Adminstrations.' };
                this.submitting = false;
                this.showMsg = true;
            },
            complete: () => {
                // Display results
                this.submitting = false;
                this.showMsg = true;

                if (this.msg.SUCCESS) {
                    this.closeDialog(true);
                } else {
                    this.dialog.open(ErrorMsgDialogComponent, {
                        width: '400px',
                        data: { title: 'Error Saving Service', message: this.msg.MSG }
                    });
                }
            }
        });
    }

    addReferenceToForm() {
        // Add SSDP Components
        this.ssdpComponents.forEach((ssdpComponent) => {
            this.form.addControl(
                ssdpComponent.NAME!,
                new UntypedFormControl({
                    value: false,
                    disabled: ssdpComponent.ACTIVE !== true
                })
            );
        });

        // Add Federal Category checkboxes
        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                this.form.addControl(
                    federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString(),
                    new UntypedFormControl(false)
                );
            }
        });

        // Add Service Periods
        this.enrollmentPeriods.forEach((enrollmentPeriod) => {
            this.form.addControl(enrollmentPeriod.PERIOD!, new UntypedFormControl(false));
        });
    }

    setForm(partyService: PartyServices) {
        this.form.patchValue({
            name: partyService.SERVICE_NAME,
            description: partyService.DESCRIPTION,
            serviceCode: partyService.SERVICE_CODE,
            federalCode: this.stateServices.find((stateService: FederalCodes) => stateService.ID === partyService.FEDERAL_CODES?.ID),
            mpo: this.measurableProgramObjectives.find((mpo: MeasurableProgramObjectives) => mpo.ID === partyService.MEASURABLE_PROGRAM_OBJECTIVES?.ID),
            serviceHour: partyService.SERVICE_HOURS?.NAME,
            federalCategory: this.getParentFederalCategory(partyService.PARENT_SERVICE_TYPES!),
            serviceCategory: partyService.SERVICE_CATEGORIES?.CATEGORY,
            serviceProvider: partyService.SERVICE_PROVIDER?.TYPE,
            serviceStatus: partyService.PARTY_SERVICE_STATUS_TYPES?.TYPE
        });

        // Region
        if (partyService.REGIONS_ID) {
            this.selectRegionIds = [partyService.REGIONS_ID];
            this.chosenRegion = partyService.REGION!;
        }

        // SSDP Components
        if (partyService.SSDP_COMPONENTS) {
            let patchedSsdpComponents: any = {};
            partyService.SSDP_COMPONENTS.forEach((ssdpComponent) => {
                patchedSsdpComponents[ssdpComponent.NAME!] = true;
            });
            this.form.patchValue(patchedSsdpComponents);
        }

        // Child Federal Category
        if (partyService.CHILD_SERVICE_TYPES) {
            let childFederalCategory = this.getChildFederalCategory(partyService.PARENT_SERVICE_TYPES!, partyService.CHILD_SERVICE_TYPES!);
            if (childFederalCategory) {
                let patched: any = {};
                if (childFederalCategory.CHILD_SERVICE_TYPES) {
                    patched[childFederalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + childFederalCategory.CHILD_SERVICE_TYPES.ID?.toString()] = true;
                }
                this.form.patchValue(patched);
            }
        }

        // Grades
        if (partyService.GRADES) {
            this.grades = JSON.parse(JSON.stringify(partyService.GRADES));
        }

        // Enrollment Periods
        if (partyService.ENROLLMENT_PERIODS) {
            let patchedEnrollmentPeriods: any = {};
            partyService.ENROLLMENT_PERIODS.forEach((enrollmentPeriod) => {
                patchedEnrollmentPeriods[enrollmentPeriod.PERIOD!] = true;
            });
            this.form.patchValue(patchedEnrollmentPeriods);
        }

        // View/Edit mode
        if (this.data.mode === 'View') {
            this.disableFieldsAll();
        } else {
            if (this.form.get('federalCode')?.value) {
                this.disableStateServiceFields();

                let stateService: FederalCodes = this.form.get('federalCode')?.value;
                if (stateService.SERVICE_TYPES_ENABLED) {
                    this.enableFields(['federalCategory']);

                    this.federalCategories.forEach((fc) => {
                        let found = stateService.SERVICE_TYPES_ENABLED?.find(
                            (ste) => ste.PARENT_SERVICE_TYPES_ID === fc.PARENT_SERVICE_TYPES_ID && !fc.CHILD_SERVICE_TYPES
                        );
                        if (found) {
                            fc.ENABLED = true;
                            fc.AUTO_CHILD_ENABLED = found;
                        } else {
                            fc.ENABLED = false;
                        }
                    });
                } else {
                    this.federalCategories.forEach((fc) => {
                        fc.ENABLED = false;
                    });
                }

                if (stateService.ENROLLMENT_PERIODS && stateService.ENROLLMENT_PERIODS.length > 0) {
                    this.set_ENROLLMENT_PERIODS_DISABLED();
                } else {
                    this.set_ENROLLMENT_PERIODS_ENABLED();
                }

                if (stateService.ACTIVE) {
                    this.set_SERVICE_STATUS_ENABLED();
                } else {
                    this.set_SERVICE_STATUS_DISABLED();
                }
            } else if (this.form.get('mpo')?.value) {
                this.disableMpoFields();

                let mpo: MeasurableProgramObjectives = this.form.get('mpo')?.value;
                if (mpo.SERVICE_TYPES_ENABLED) {
                    this.enableFields(['federalCategory']);

                    this.federalCategories.forEach((fc) => {
                        let found = mpo.SERVICE_TYPES_ENABLED?.find(
                            (ste) => ste.PARENT_SERVICE_TYPES_ID === fc.PARENT_SERVICE_TYPES_ID && !fc.CHILD_SERVICE_TYPES
                        );
                        if (found) {
                            fc.ENABLED = true;
                            fc.AUTO_CHILD_ENABLED = found;
                        } else {
                            fc.ENABLED = false;
                        }
                    });
                } else {
                    this.federalCategories.forEach((fc) => {
                        fc.ENABLED = false;
                    });
                }

                if (mpo.ENROLLMENT_PERIODS && mpo.ENROLLMENT_PERIODS.length > 0) {
                    this.set_ENROLLMENT_PERIODS_DISABLED();
                } else {
                    this.set_ENROLLMENT_PERIODS_ENABLED();
                }

                if (mpo.ACTIVE) {
                    this.set_SERVICE_STATUS_ENABLED();
                } else {
                    this.set_SERVICE_STATUS_DISABLED();
                }
            } else if (this.form.get('federalCategory')?.value) {
                this.disableFederalCategoryFields();

                let parentFederalCategory: any = this.getParentFederalCategory(partyService.PARENT_SERVICE_TYPES!);
                let findMpo: MeasurableProgramObjectives = this.form.get('mpo')?.value;
                let findFederalCategory: any;

                if (partyService.CHILD_SERVICE_TYPES!) {
                    findFederalCategory = this.getChildFederalCategory(partyService.PARENT_SERVICE_TYPES!, partyService.CHILD_SERVICE_TYPES!);
                } else {
                    findFederalCategory = this.federalCategories.find((federalCategory: FederalCategories) => {
                        return federalCategory.PARENT_SERVICE_TYPES_ID === parentFederalCategory.ID && !federalCategory.CHILD_SERVICE_TYPES;
                    })!;
                }

                // If mpo has grades
                if (findMpo?.GRADES) {
                    this.grades = JSON.parse(JSON.stringify(findMpo.GRADES));
                }
                // If federalCategory has grade
                else if (findFederalCategory && findFederalCategory.GRADES) {
                    this.grades = JSON.parse(JSON.stringify(findFederalCategory.GRADES));
                }
                // Else enable grades
                else {
                    this.enableFields(['grades']);
                }

                this.set_SERVICE_STATUS_ENABLED();
            } else {
                this.federalCategories.forEach((fc) => {
                    fc.ENABLED = true;
                    fc.AUTO_CHILD_ENABLED = undefined;
                });

                this.set_SERVICE_STATUS_ENABLED();
            }
        }
    }

    generatePayload(): any {
        let payload: any = {};
        let partyService: PartyServices = new PartyServices();

        // Attach ID if editing
        if (this.data.mode === 'Edit') {
            partyService.ID = this.data.serviceAdministrationId;
        }

        partyService.SERVICE_NAME = this.form.get('name')?.value;
        partyService.DESCRIPTION = this.form.get('description')?.value;
        partyService.SERVICE_CODE = this.form.get('serviceCode')?.value;
        if (this.chosenRegion) {
            partyService.REGIONS_ID = this.chosenRegion.ID;
            partyService.REGION = this.chosenRegion;
        }
        if (this.form.get('federalCode')?.value) {
            partyService.FEDERAL_CODES_ID = this.form.get('federalCode')?.value.ID;
            partyService.FEDERAL_CODES = this.form.get('federalCode')?.value;
        }
        if (this.form.get('mpo')?.value) {
            partyService.MEASURABLE_PROGRAM_OBJECTIVES_ID = this.form.get('mpo')?.value.ID;
            partyService.MEASURABLE_PROGRAM_OBJECTIVES = this.form.get('mpo')?.value;
        }
        if (this.form.get('serviceHour')?.value) {
            let serviceHour = this.serviceHours.find((sh) => sh.NAME === this.form.get('serviceHour')?.value);
            if (serviceHour) {
                partyService.SERVICE_HOURS_ID = serviceHour.ID;
                partyService.SERVICE_HOURS = serviceHour;
            }
        }
        if (this.form.get('federalCategory')?.value) {
            let parentFederalCategory: FederalCategories | undefined;
            let childFederalCategory: FederalCategories | undefined;
            parentFederalCategory = this.getParentFederalCategory(this.form.get('federalCategory')?.value.PARENT_SERVICE_TYPES);

            this.federalCategories.forEach((fc) => {
                if (fc.CHILD_SERVICE_TYPES) {
                    let childFederalCategoryFormControl = this.form.get(fc.CHILD_SERVICE_TYPES.TYPE! + '|' + fc.CHILD_SERVICE_TYPES.ID?.toString());
                    if (childFederalCategoryFormControl) {
                        if (childFederalCategoryFormControl.value) {
                            childFederalCategory = fc;
                        }
                    }
                }
            });

            if (parentFederalCategory) {
                partyService.PARENT_SERVICE_TYPES_ID = parentFederalCategory.PARENT_SERVICE_TYPES_ID;
                partyService.PARENT_SERVICE_TYPES = parentFederalCategory.PARENT_SERVICE_TYPES;
            }

            if (childFederalCategory) {
                partyService.CHILD_SERVICE_TYPES_ID = childFederalCategory.CHILD_SERVICE_TYPES_ID;
                partyService.CHILD_SERVICE_TYPES = childFederalCategory.CHILD_SERVICE_TYPES;
            }
        }
        if (this.form.get('serviceCategory')?.value) {
            let serviceCategory = this.serviceCategories.find((sh) => sh.CATEGORY === this.form.get('serviceCategory')?.value);
            if (serviceCategory) {
                partyService.SERVICE_CATEGORIES_ID = serviceCategory.ID;
                partyService.SERVICE_CATEGORIES = serviceCategory;
            }
        }
        if (this.form.get('serviceProvider')?.value) {
            let serviceProvider = this.serviceProviders.find((sp) => sp.TYPE === this.form.get('serviceProvider')?.value);
            if (serviceProvider) {
                partyService.SERVICE_PROVIDER_PARTY_ROLE_TYPES_ID = serviceProvider.ID;
                partyService.SERVICE_PROVIDER = serviceProvider;
            }
        }
        if (this.form.get('serviceStatus')?.value) {
            let serviceStatus = this.partyServiceStatusTypes.find((sp) => sp.TYPE === this.form.get('serviceStatus')?.value);
            if (serviceStatus) {
                partyService.PARTY_SERVICE_STATUS_TYPES_ID = serviceStatus.ID;
                partyService.PARTY_SERVICE_STATUS_TYPES = serviceStatus;
            }
        }

        if (this.grades) {
            partyService.GRADES_FLAT = this.grades.map((g) => g.GRADES).join(',');
            partyService.GRADES = this.grades;
        }

        partyService.SSDP_COMPONENTS = [];
        this.ssdpComponents.forEach((ssdpComponent) => {
            let ssdpComponentFormControl = this.form.get([ssdpComponent.NAME!]);
            if (ssdpComponentFormControl) {
                if (ssdpComponentFormControl.value) {
                    partyService.SSDP_COMPONENTS!.push(ssdpComponent);
                }
            }
        });

        partyService.ENROLLMENT_PERIODS = [];
        this.enrollmentPeriods.forEach((enrollmentPeriod) => {
            let enrollmentPeriodFormControl = this.form.get([enrollmentPeriod.PERIOD!]);
            if (enrollmentPeriodFormControl) {
                if (enrollmentPeriodFormControl.value) {
                    partyService.ENROLLMENT_PERIODS!.push(enrollmentPeriod);
                }
            }
        });

        payload.partyService = partyService;

        // Edited fields
        if (this.data.mode === 'Edit') {
            payload.editedFields = this.generateEditedFields();
        }

        return payload;
    }

    generateEditedFields() {
        if (this.tableDataSource.filteredData) {
            if (this.tableDataSource.filteredData.length > 0) {
                let editedFields: any[] = [];

                this.tableDataSource.filteredData.forEach((data) => {
                    editedFields.push({
                        CHANGED_FIELD: data.CHANGED_FIELD,
                        CHANGED_VALUE: data.VALUE
                    });
                });

                return editedFields;
            } else {
                return;
            }
        } else {
            return;
        }
    }

    // Emitters
    regionEventEmitter(regions: Region[]) {
        this.chosenRegion = regions[0];
    }
    gradeEventEmitter(grades: Grade[]) {
        //this.grades = grades;

        if (this.grades) {
            this.formChanges['grades'].CHANGED_VALUE = this.grades
                .sort((a: any, b: any) => (a.INDEX! > b.INDEX! ? 1 : -1))
                .map((g) => g.GRADES)
                .join(', ');
        }
        this.updateDataSource();
    }

    stateServiceChange(event: any) {
        let stateService: FederalCodes = event.value;

        // Fields affected
        let fields = [];
        fields.push('mpo');
        fields.push('serviceHour');
        fields.push('federalCategory');
        fields.push('serviceCategory');
        fields.push('serviceProvider');
        fields.push('grades');

        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                fields.push(federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString());
            }
        });

        if (stateService) {
            if (stateService.SERVICE_TYPES_ENABLED) {
                fields.splice(
                    fields.findIndex((f) => f === 'federalCategory'),
                    1
                );
                this.enableFields(['federalCategory']);
                this.form.get('federalCategory')?.patchValue('');

                this.federalCategories.forEach((fc) => {
                    let found = stateService.SERVICE_TYPES_ENABLED?.find(
                        (ste) => ste.PARENT_SERVICE_TYPES_ID === fc.PARENT_SERVICE_TYPES_ID && !fc.CHILD_SERVICE_TYPES
                    );
                    if (found) {
                        fc.ENABLED = true;
                    }
                });
            } else {
                this.federalCategories.forEach((fc) => {
                    fc.ENABLED = false;
                });
            }
            this.disableFields(fields);

            fields.forEach((field) => {
                switch (field) {
                    case 'mpo':
                        this.form
                            .get(field)
                            ?.patchValue(
                                stateService.MEASURABLE_PROGRAM_OBJECTIVES
                                    ? this.measurableProgramObjectives.find(
                                          (mpo: MeasurableProgramObjectives) => mpo.ID === stateService.MEASURABLE_PROGRAM_OBJECTIVES?.ID
                                      )
                                    : ''
                            );
                        break;
                    case 'serviceHour':
                        this.form.get(field)?.patchValue(stateService.SERVICE_HOURS ? stateService.SERVICE_HOURS.NAME : '');
                        break;
                    case 'federalCategory':
                        this.form
                            .get(field)
                            ?.patchValue(stateService.PARENT_SERVICE_TYPES ? this.getParentFederalCategory(stateService.PARENT_SERVICE_TYPES!) : '');
                        break;
                    case 'serviceCategory':
                        this.form.get(field)?.patchValue(stateService.SERVICE_CATEGORIES ? stateService.SERVICE_CATEGORIES.CATEGORY : '');
                        break;
                    case 'serviceProvider':
                        this.form.get(field)?.patchValue(stateService.SERVICE_PROVIDER ? stateService.SERVICE_PROVIDER.TYPE : '');
                        break;
                    case 'grades':
                        this.grades = JSON.parse(JSON.stringify(stateService.GRADES));
                        break;
                }
            });

            // SSDP Components Enable/Disable
            this.set_SSDP_COMPONENTS_ENABLED(stateService.SSDP_COMPONENTS_ENABLED);
            // SSDP Components Auto-select
            this.set_SSDP_COMPONENTS(stateService.SSDP_COMPONENTS);
            // Enrollment Periods Enable/Disable
            if (stateService.ENROLLMENT_PERIODS && stateService.ENROLLMENT_PERIODS.length > 0) {
                this.set_ENROLLMENT_PERIODS_DISABLED();
            } else {
                this.set_ENROLLMENT_PERIODS_ENABLED();
            }
            // Enrollment Periods Auto-select
            this.set_ENROLLMENT_PERIODS(stateService.ENROLLMENT_PERIODS);
            // Child Federal Category
            this.set_CHILD_SERVICE_TYPES(stateService.CHILD_SERVICE_TYPES);
            // Enable Service Category if NULL is found
            if (!stateService.SERVICE_CATEGORIES?.CATEGORY) {
                this.enableFields(['serviceCategory']);
            }
            // Enable Service Provider if NULL is found
            if (!stateService.SERVICE_PROVIDER?.TYPE) {
                this.enableFields(['serviceProvider']);
            }
            if (stateService.ACTIVE) {
                this.set_SERVICE_STATUS_ENABLED();
            } else {
                this.set_SERVICE_STATUS_DISABLED();
            }
        } else {
            this.enableFields(fields);
            this.ssdpComponents.forEach((ssdpComponent) => {
                if (ssdpComponent.ACTIVE === true) {
                    this.enableFields([ssdpComponent.NAME!]);
                }
            });
            this.enrollmentPeriods.forEach((enrollmentPeriod) => {
                this.enableFields([enrollmentPeriod.PERIOD!]);
            });
            this.federalCategories.forEach((fc) => {
                fc.ENABLED = true;
                fc.AUTO_CHILD_ENABLED = undefined;
            });
            this.set_SERVICE_STATUS_ENABLED();
            this.resetFields(fields);
        }
    }

    disableStateServiceFields() {
        // Fields affected
        let fields = [];
        fields.push('mpo');
        fields.push('serviceHour');
        fields.push('federalCategory');
        fields.push('serviceCategory');
        fields.push('serviceProvider');
        fields.push('grades');

        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                fields.push(federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString());
            }
        });

        this.disableFields(fields);
    }

    mpoChange(event: any) {
        let mpo: MeasurableProgramObjectives = event.value;

        // Fields affected
        let fields = [];
        fields.push('serviceHour');
        fields.push('federalCategory');
        fields.push('serviceCategory');
        fields.push('serviceProvider');
        fields.push('grades');

        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                fields.push(federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString());
            }
        });

        if (mpo) {
            if (mpo.SERVICE_TYPES_ENABLED) {
                fields.splice(
                    fields.findIndex((f) => f === 'federalCategory'),
                    1
                );
                this.enableFields(['federalCategory']);
                this.form.get('federalCategory')?.patchValue('');

                this.federalCategories.forEach((fc) => {
                    const found = mpo.SERVICE_TYPES_ENABLED?.find((ste) => {
                        // Child row
                        if (fc.CHILD_SERVICE_TYPES) {
                            return ste.PARENT_SERVICE_TYPES_ID === fc.PARENT_SERVICE_TYPES_ID && ste.CHILD_SERVICE_TYPES_ID === fc.CHILD_SERVICE_TYPES.ID;
                        }

                        // Parent row
                        return ste.PARENT_SERVICE_TYPES_ID === fc.PARENT_SERVICE_TYPES_ID;
                    });

                    fc.ENABLED = !!found;

                    if (found && found.CHILD_SERVICE_TYPES_ID) {
                        fc.AUTO_CHILD_ENABLED = found;
                    }
                });
            } else {
                this.federalCategories.forEach((fc) => {
                    fc.ENABLED = false;
                });
            }

            this.disableFields(fields);

            fields.forEach((field) => {
                switch (field) {
                    case 'serviceHour':
                        this.form.get(field)?.patchValue(mpo.SERVICE_HOURS ? mpo.SERVICE_HOURS.NAME : '');
                        break;
                    case 'federalCategory':
                        this.form.get(field)?.patchValue(mpo.PARENT_SERVICE_TYPES ? this.getParentFederalCategory(mpo.PARENT_SERVICE_TYPES!) : '');
                        break;
                    case 'serviceCategory':
                        this.form.get(field)?.patchValue(mpo.SERVICE_CATEGORIES ? mpo.SERVICE_CATEGORIES.CATEGORY : '');
                        break;
                    case 'serviceProvider':
                        this.form.get(field)?.patchValue(mpo.SERVICE_PROVIDER ? mpo.SERVICE_PROVIDER.TYPE : '');
                        break;
                    case 'grades':
                        this.grades = JSON.parse(JSON.stringify(mpo.GRADES));
                        break;
                }
            });

            // SSDP Components Enable/Disable
            this.set_SSDP_COMPONENTS_ENABLED(mpo.SSDP_COMPONENTS_ENABLED);
            // SSDP Components Auto-select
            this.set_SSDP_COMPONENTS(mpo.SSDP_COMPONENTS);
            // Enrollment Periods Enable/Disable
            if (mpo.ENROLLMENT_PERIODS && mpo.ENROLLMENT_PERIODS.length > 0) {
                this.set_ENROLLMENT_PERIODS_DISABLED();
            } else {
                this.set_ENROLLMENT_PERIODS_ENABLED();
            }
            // Enrollment Periods Auto-select
            this.set_ENROLLMENT_PERIODS(mpo.ENROLLMENT_PERIODS);
            // Child Federal Category
            this.set_CHILD_SERVICE_TYPES(mpo.CHILD_SERVICE_TYPES);
            // Enable Service Category if NULL is found
            if (!mpo.SERVICE_CATEGORIES?.CATEGORY) {
                this.enableFields(['serviceCategory']);
            }
            // Enable Service Provider if NULL is found
            if (!mpo.SERVICE_PROVIDER?.TYPE) {
                this.enableFields(['serviceProvider']);
            }
            if (mpo.ACTIVE) {
                this.set_SERVICE_STATUS_ENABLED();
            } else {
                this.set_SERVICE_STATUS_DISABLED();
            }
        } else {
            this.enableFields(fields);
            this.ssdpComponents.forEach((ssdpComponent) => {
                if (ssdpComponent.ACTIVE === true) {
                    this.enableFields([ssdpComponent.NAME!]);
                }
            });
            this.enrollmentPeriods.forEach((enrollmentPeriod) => {
                this.enableFields([enrollmentPeriod.PERIOD!]);
            });
            this.federalCategories.forEach((fc) => {
                fc.ENABLED = true;
                fc.AUTO_CHILD_ENABLED = undefined;
            });
            this.set_SERVICE_STATUS_ENABLED();
            this.resetFields(fields);
        }
    }

    disableMpoFields() {
        // Fields affected
        let fields = [];
        fields.push('serviceHour');
        fields.push('federalCategory');
        fields.push('serviceCategory');
        fields.push('serviceProvider');
        fields.push('grades');

        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                fields.push(federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString());
            }
        });

        this.disableFields(fields);
    }

    /*
     * SSDP_COMPONENTS_ENABLED
     */
    set_SSDP_COMPONENTS_ENABLED(SSDP_COMPONENTS_ENABLED?: SsdpComponents[]) {
        if (SSDP_COMPONENTS_ENABLED) {
            this.ssdpComponents.forEach((ssdpComponent) => {
                if (SSDP_COMPONENTS_ENABLED!.findIndex((enabled) => enabled.ID === ssdpComponent.ID) >= 0) {
                    this.enableFields([ssdpComponent.NAME!]);
                } else {
                    this.disableFields([ssdpComponent.NAME!]);
                }
            });
        } else {
            this.ssdpComponents.forEach((ssdpComponent) => {
                this.disableFields([ssdpComponent.NAME!]);
            });
        }
    }

    /*
     * SSDP_COMPONENTS
     */
    set_SSDP_COMPONENTS(SSDP_COMPONENTS?: SsdpComponents[]) {
        if (SSDP_COMPONENTS) {
            this.ssdpComponents.forEach((ssdpComponent) => {
                if (SSDP_COMPONENTS!.findIndex((enabled) => enabled.ID === ssdpComponent.ID) >= 0) {
                    this.form.get([ssdpComponent.NAME!])?.patchValue(true);
                } else {
                    this.form.get([ssdpComponent.NAME!])?.patchValue(false);
                }
            });
        } else {
            this.ssdpComponents.forEach((ssdpComponent) => {
                this.form.get([ssdpComponent.NAME!])?.patchValue(false);
            });
        }
    }

    /*
     * ENROLLMENT_PERIODS_ENABLED/DISABLED
     */
    set_ENROLLMENT_PERIODS_ENABLED() {
        this.enrollmentPeriods.forEach((enrollmentPeriod) => {
            this.enableFields([enrollmentPeriod.PERIOD!]);
        });
    }
    set_ENROLLMENT_PERIODS_DISABLED() {
        this.enrollmentPeriods.forEach((enrollmentPeriod) => {
            this.disableFields([enrollmentPeriod.PERIOD!]);
        });
    }

    /*
     * ENROLLMENT_PERIODS
     */
    set_ENROLLMENT_PERIODS(ENROLLMENT_PERIODS?: EnrollmentPeriods[]) {
        if (ENROLLMENT_PERIODS) {
            this.enrollmentPeriods.forEach((enrollmentPeriod) => {
                if (ENROLLMENT_PERIODS!.findIndex((enabled) => enabled.ID === enrollmentPeriod.ID) >= 0) {
                    this.form.get([enrollmentPeriod.PERIOD!])?.patchValue(true);
                } else {
                    this.form.get([enrollmentPeriod.PERIOD!])?.patchValue(false);
                }
            });
        } else {
            this.enrollmentPeriods.forEach((enrollmentPeriod) => {
                this.form.get([enrollmentPeriod.PERIOD!])?.patchValue(false);
            });
        }
    }

    /*
     * CHILD_SERVICE_TYPES
     */
    set_CHILD_SERVICE_TYPES(CHILD_SERVICE_TYPES?: PartyServiceTypes) {
        if (CHILD_SERVICE_TYPES) {
            this.resetFederalCategoryChildCheckboxes(CHILD_SERVICE_TYPES);
            if (this.form.get(CHILD_SERVICE_TYPES.TYPE! + '|' + CHILD_SERVICE_TYPES.ID?.toString())) {
                this.form.get(CHILD_SERVICE_TYPES.TYPE! + '|' + CHILD_SERVICE_TYPES.ID?.toString())?.patchValue(true);
            }
        } else {
            this.resetFederalCategoryChildCheckboxes();
        }
    }

    /*
     * ENROLLMENT_PERIODS_ENABLED/DISABLED
     */
    set_SERVICE_STATUS_ENABLED() {
        this.enableFields(['serviceStatus']);
    }
    set_SERVICE_STATUS_DISABLED() {
        this.disableFields(['serviceStatus']);
    }

    federalCategoryChange(parentFederalCategory: PartyServiceTypes, childFederalCategory?: PartyServiceTypes, event?: any) {
        this.resetFederalCategoryChildCheckboxes(childFederalCategory);

        let findMpo: MeasurableProgramObjectives = this.form.get('mpo')?.value;
        let findFederalCategory: FederalCategories;
        let findParentFederalCategory = this.getParentFederalCategory(parentFederalCategory);

        if (childFederalCategory && event.checked) {
            findFederalCategory = this.getChildFederalCategory(parentFederalCategory, childFederalCategory)!;
        } else {
            findFederalCategory = this.federalCategories.find((federalCategory: FederalCategories) => {
                return federalCategory.PARENT_SERVICE_TYPES_ID === parentFederalCategory.ID && !federalCategory.CHILD_SERVICE_TYPES;
            })!;
        }

        if (findParentFederalCategory) {
            this.form.patchValue({ federalCategory: findParentFederalCategory });

            if (findParentFederalCategory.AUTO_CHILD_ENABLED) {
                let autoPickChild = this.getChildFederalCategoryById(
                    findParentFederalCategory.AUTO_CHILD_ENABLED.PARENT_SERVICE_TYPES_ID!,
                    findParentFederalCategory.AUTO_CHILD_ENABLED.CHILD_SERVICE_TYPES_ID!
                )!;

                if (autoPickChild) {
                    let childFederalCategory = this.getChildFederalCategory(autoPickChild.PARENT_SERVICE_TYPES!, autoPickChild.CHILD_SERVICE_TYPES!);
                    if (childFederalCategory) {
                        let patched: any = {};
                        if (childFederalCategory.CHILD_SERVICE_TYPES) {
                            patched[childFederalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + childFederalCategory.CHILD_SERVICE_TYPES.ID?.toString()] = true;
                        }
                        this.form.patchValue(patched);
                    }
                }
            }
        }

        if (findFederalCategory) {
            // Fields affected
            let fields: any = [];
            fields.push('serviceCategory');
            fields.push('serviceProvider');
            fields.push('grades');

            if (findFederalCategory) {
                this.disableFields(fields);

                fields.forEach((field: string) => {
                    switch (field) {
                        case 'serviceCategory':
                            this.form.get(field)?.patchValue(findFederalCategory.SERVICE_CATEGORIES ? findFederalCategory.SERVICE_CATEGORIES.CATEGORY : '');
                            break;
                        case 'serviceProvider':
                            if (findFederalCategory.SERVICE_PROVIDER) {
                                this.form.get(field)?.patchValue(findFederalCategory.SERVICE_PROVIDER ? findFederalCategory.SERVICE_PROVIDER.TYPE : '');
                            } else {
                                this.resetFields([field]);
                                this.enableFields([field]);
                            }
                            break;
                        case 'grades':
                            if (findMpo?.GRADES) {
                                this.grades = JSON.parse(JSON.stringify(findMpo.GRADES));
                            } else if (findFederalCategory.GRADES) {
                                this.grades = JSON.parse(JSON.stringify(findFederalCategory.GRADES));
                            } else {
                                this.resetFields([field]);
                                this.enableFields([field]);
                            }
                            break;
                    }
                });
            } else {
                this.enableFields(fields);
                this.ssdpComponents.forEach((ssdpComponent) => {
                    this.enableFields([ssdpComponent.NAME!]);
                });
                this.enrollmentPeriods.forEach((enrollmentPeriod) => {
                    this.enableFields([enrollmentPeriod.PERIOD!]);
                });
                this.resetFields(fields);
            }
        }
    }

    disableFederalCategoryFields() {
        // Fields affected
        let fields = [];
        fields.push('serviceCategory');
        fields.push('serviceProvider');
        fields.push('grades');

        this.disableFields(fields);
    }

    getParentFederalCategory(parentFederalCategory: PartyServiceTypes) {
        let findParentFederalCategory;

        if (parentFederalCategory) {
            findParentFederalCategory = this.federalCategories.find((federalCategory: FederalCategories) => {
                return federalCategory.PARENT_SERVICE_TYPES_ID === parentFederalCategory.ID && !federalCategory.CHILD_SERVICE_TYPES;
            });
        }

        return findParentFederalCategory;
    }

    getChildFederalCategory(parentFederalCategory: PartyServiceTypes, childFederalCategory: PartyServiceTypes) {
        let findFederalCategory;

        findFederalCategory = this.federalCategories.find((federalCategory: FederalCategories) => {
            return federalCategory.PARENT_SERVICE_TYPES_ID === parentFederalCategory.ID && federalCategory.CHILD_SERVICE_TYPES_ID === childFederalCategory.ID;
        });

        return findFederalCategory;
    }

    getChildFederalCategoryById(parentFederalCategoryId: number, childFederalCategoryId: number) {
        let findFederalCategory;
        findFederalCategory = this.federalCategories.find((federalCategory: FederalCategories) => {
            return federalCategory.PARENT_SERVICE_TYPES_ID === parentFederalCategoryId && federalCategory.CHILD_SERVICE_TYPES_ID === childFederalCategoryId;
        });

        return findFederalCategory;
    }

    resetFederalCategoryChildCheckboxes(childFederalCategory?: PartyServiceTypes) {
        let patched: any = {};

        this.federalCategories.forEach((federalCategory) => {
            if (federalCategory.CHILD_SERVICE_TYPES) {
                if (federalCategory.CHILD_SERVICE_TYPES.ID !== childFederalCategory?.ID) {
                    patched[federalCategory.CHILD_SERVICE_TYPES.TYPE! + '|' + federalCategory.CHILD_SERVICE_TYPES.ID?.toString()] = false;
                }
            }
        });

        this.form.patchValue(patched);
    }

    disableFields(fields: string[]) {
        if (fields) {
            fields.forEach((field) => {
                if (this.form.get([field])) {
                    this.form.get([field])?.disable();
                } else if (field === 'region') {
                    this.regionDisabled = true;
                } else if (field === 'grades') {
                    this.gradesDisabled = true;
                }
            });
        }
    }

    enableFields(fields: string[]) {
        if (fields) {
            fields.forEach((field) => {
                if (this.form.get([field])) {
                    if (this.disabledFields.findIndex((df) => df === field) < 0) {
                        this.form.get([field])?.enable();
                    }
                } else if (field === 'region') {
                    this.regionDisabled = false;
                } else if (field === 'grades') {
                    this.gradesDisabled = false;
                }
            });
        }
    }

    enabledFieldsAll() {
        this.form.enable();
        this.regionDisabled = false;
        this.gradesDisabled = false;

        // Keep permanent disabled fields disabled
        this.disabledFields.forEach((df) => {
            this.disableFields([df]);
        });
    }
    disableFieldsAll() {
        this.form.disable();
        this.regionDisabled = true;
        this.gradesDisabled = true;
    }

    resetFields(fields: string[]) {
        if (fields) {
            fields.forEach((field) => {
                if (this.form.get([field])) {
                    this.form.get([field])?.patchValue('');
                } else if (field === 'grades') {
                    this.grades = [];
                }
            });
        }
    }

    closeDialog(refresh?: boolean) {
        this.dialogRef.close(refresh);
    }
}
